<script>
  import { onMount } from 'svelte'
  import { y, showLabelPage, posBeforeLabel, posBeforeBuy } from '../stores.js'
  import { showModal } from '../stores.js'
  export let content

  let sections = content.item_list

  function getCoords(elem) {
    let e = document.getElementById(elem)
    let box = e.getBoundingClientRect()
    return box.top + window.pageYOffset - 60
  }

  function scrollTo(section) {
    window.scrollTo(0, getCoords(section))
  }

  onMount(() => {
    gsap.from('.menu-item', { opacity: 0, y: 40, duration: 0.2, stagger: 0.2 })
  })
</script>

<div>
  <ul>
    {#each sections as item}
      <li class="menu-item" on:click={() => scrollTo(item.name)}>
        <a>{item.title}</a>
      </li>
    {/each}
    <li
      on:click={() => {
        showLabelPage.set(true)
        posBeforeLabel.set($y)
      }}
      class="menu-item">
      <a>Italian shops & hotels</a>
    </li>
    <li
      on:click={() => {
        showModal.set(!$showModal)
        document.body.style.position = 'fixed'
        document.body.style.overflowY = 'hidden'
        posBeforeBuy.set($y)
      }}
      class="menu-item">
      <a>Buy & Download</a>
    </li>
  </ul>
</div>

<style lang="scss">
  @import '../responsive.scss';
  ul {
    font-family: 'Arteria-Regular';
    font-size: 5em;
    max-width: 50vw;
    display: grid;
    grid-template-columns: minmax(306px, max-content) max-content;
    grid-column-gap: 0.3em;
    grid-auto-flow: dense;
    li {
      line-height: 1em;
      grid-column: 1;
      a {
        cursor: pointer;
        color: var(--light-accent);
        transition: color 0.2s;
        &:hover {
          color: var(--light);
        }
      }
      &:nth-child(n + 6) {
        grid-column: 2;
      }
    }

    @include for-tablet {
      font-size: 4rem;
      grid-template-columns: minmax(240px, max-content) max-content;
      grid-column-gap: 0;
    }

    @include for-phone {
      font-size: 2.5rem;
      li:nth-child(n + 6) {
        grid-column: 1;
      }
    }
  }
</style>
